<template>
  <div class="c-scheme-card">
    <div class="c-scheme-card__title">我的方案</div>
    <div class="c-scheme-card__warp">
      <div
        v-for="(item, index) in schemeList"
        :key="index"
        class="c-scheme-card__item"
        :class="item.supplement ? 'c-scheme-card__item__supplement' : ''"
        @click="clickItem(item)"
      >
        <template v-if="!item.supplement">
          <div class="c-scheme-card__item__row">
            <img class="c-scheme-card__item__bg" :src="item.icon" />
            <div class="c-scheme-card__item__name">
              {{ item.name }}
            </div>
          </div>
          <div class="c-scheme-card__item__desc">
            {{ item.description }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  computed: {
    ...mapState({
      appInfo: state => state.product.appInfo,
    }),
    schemeList() {
      const schemeList = [].concat(this.appInfo.service_package || [])
      const surplus = schemeList.length % 3
      let supplement = surplus > 0 ? 3 - surplus : 0
      while (supplement > 0) {
        schemeList.push({
          supplement: true
        })
        supplement--
      }
      return schemeList
    }
  },
  methods: {
    clickItem(item) {
      if (item.supplement) return
      this.$emit('click-item', item)
    },
  }

}
</script>

<style lang="scss">
.c-scheme-card {
  background-color: #fff;
  padding-top: 0.26rem;
  .c-scheme-card__title {
    font-size: 16px;
    font-weight: bold;
    padding: 0 0.26rem 0.3rem;
  }
  .c-scheme-card__warp {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .c-scheme-card__item {
      position: relative;
      width: 33.33%;
      padding: 26px;
      border-right: 2px solid #f2f2f2;
      cursor: pointer;
      .c-scheme-card__item__row {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .c-scheme-card__item__bg {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        .c-scheme-card__item__name {
          font-size: 0.15rem;
          line-height: 0.24rem;
          margin-left: 10px;
          font-weight: bold;
          color: rgb(51, 51, 51);
        }
      }
      .c-scheme-card__item__desc {
        font-size: 0.14rem;
        line-height: 0.24rem;
        color: #7f7f7f;
      }
    }
    .c-scheme-card__item::after {
      position: absolute;
      content: '';
      left: -10px;
      right: -10px;
      top: 0;
      height: 1px;
      border-top: 2px solid #f2f2f2;
    }
    .c-scheme-card__item:nth-of-type(3n) {
      border-right: 0;
    }
    .c-scheme-card__item:hover {
      position: relative;
      z-index: 1;
      border-right-color: transparent;
      box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
      .c-scheme-card__item__name {
        color: #1890ff;
      }
    }
    .c-scheme-card__item__supplement {
      cursor: default;
      border-right-color: transparent;
    }
    .c-scheme-card__item__supplement:hover {
      box-shadow: unset;
    }
  }
}
</style>
